import 'slick-carousel';

const SELECTOR = '[data-detail-view-testimonials-carousel]';

const OPTIONS = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  dots: true,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 6000
};

class TestimonialsCarousel {
  constructor() {
    if ($(SELECTOR).size()) {

      $(SELECTOR).slick(OPTIONS);
    }
  }
}

export default TestimonialsCarousel;



// WEBPACK FOOTER //
// ./src/javascripts/DetailView/TestimonialsCarousel.js